import { useTenant } from '../../module/me';
import { BikeleasingATIcon } from './BikeleasingATIcon';
import { BikeleasingDEIcon } from './BikeleasingDEIcon';

const ICON_BY_COUNTRY = {
  AT: BikeleasingATIcon,
  DE: BikeleasingDEIcon,
} as const;

export const BikeleasingIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  const { tenant } = useTenant();
  const Icon = tenant?.countryCode ? (ICON_BY_COUNTRY[tenant.countryCode] ?? ICON_BY_COUNTRY.DE) : ICON_BY_COUNTRY.DE;
  return <Icon {...props} />;
};
